export const yr2026 = {
    zelfstandigenaftrek: 1200,
    startersaftrek: 2123,
    mkbVrijstelling: 12.70,
    zvwBijdrage: { pct: 4.85, limit: 79410 },
    arbeidskorting: [
        { low: 0, high: 11966, pct: 8.324, addition: 0 },
        { low: 11966, high: 25846, pct: 31.009, addition: 996 },
        { low: 25846, high: 45593, pct: 1.950, addition: 5300 },
        { low: 45593, high: 132921, pct: -6.510, addition: 5685 },
        { low: 132921, high: 999999999, pct: 0, addition: 0 }
    ],
    belasting: [
        { low: 0, high: 38884, pct: 35.75, addition: 0 },
        { low: 38884, high: 78427, pct: 37.56, addition: 13900 },
        { low: 78427, high: 999999999, pct: 49.50, addition: 28752 },
    ],
    heffingskorting: [
        { low: 0, high: 29737, pct: 0, addition: 3115 },
        { low: 29737, high: 78427, pct: -6.398, addition: 3115 },
        { low: 78427, high: 999999999, pct: 0, addition: 0 },
    ],
    inkomenhoogsteschaal: 78426,
    tarrifaanpassing: 0.1194,
}

